import { AddIcon, Arrow2Icon, DeleteIcon, DocumentTextIcon } from "asset/icons";
import { useState } from "react";
import capitalizeFirstLetter from "utilities/capitalizeFirstLetter";
import UploadDocModal from "./uploadDocModal";
import axios from "axios";

const SupportDocs = ({ addDocs, setAddDocs, file, setFile, showDelete, onDelete, leg }) => {
    const [showModal, setShowModal] = useState(false);
    const [uploading, setUploading] = useState(false);

    const handleUpload = async (selectedFile, userGivenName) => {
        setUploading(true);
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await axios.post("/v1/utility/upload-file", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data?.link) {
                const url = response.data.link;
                setFile({
                    name: userGivenName,
                    url: url,
                    file: selectedFile,
                });
            } else {
                console.error("Upload failed: No file URL returned.");
            }
        } catch (error) {
            console.error("Upload error:", error);
        } finally {
            setUploading(false);
            setShowModal(false);
        }
    };

    return (
        <>
            <p
                className="flex items-center font-[450] !mt-3 cursor-pointer"
                onClick={() => setAddDocs((prev) => !prev)}
            >
                <span
                    className={`rounded-full !mr-2 size-5 !border-[1.5px] grid place-items-center ${
                        addDocs ? "!border-secondary" : "bg-white"
                    }`}
                >
                    <span
                        className={`!bg-secondary rounded-full transition-all ease-in-out ${
                            addDocs ? "size-2" : "size-0"
                        }`}
                    />
                </span>
                Add Supporting Documents
            </p>

            {addDocs && (
                <div className="!pl-6 !mt-[9px] relative">
                    {file && (
                        <div className="flex items-center">
                            <Document
                                name={file?.name}
                                extension={file?.url?.split(".")?.pop()?.toUpperCase()}
                                deleteFile={() => {
                                    onDelete?.();
                                    setFile(null);
                                }}
                                showDelete={showDelete}
                            />
                            {showDelete && (
                                <DeleteIcon
                                    className="ml-1.5 350:ml-3.5 950:hidden w-[25px] h-6"
                                    onClick={() => {
                                        console.log("see wetin you click");
                                        onDelete?.();
                                        setFile(null);
                                    }}
                                />
                            )}
                        </div>
                    )}

                    <button
                        className="flex items-center gap-2 !py-2 text-[#1D2939] !mt-1"
                        onClick={(evt) => {
                            evt.preventDefault();
                            setShowModal(true);
                        }}
                    >
                        <AddIcon className="*:fill-[#1D2939]" /> {file ? "Change" : "Choose"}{" "}
                        document
                    </button>
                </div>
            )}

            {showModal && (
                <UploadDocModal
                    close={() => setShowModal(false)}
                    uploadFunc={handleUpload}
                    loading={uploading}
                />
            )}
        </>
    );
};

const Document = ({ name, extension, deleteFile, showDelete }) => {
    return (
        <div className="bg-white rounded-lg !p-6 max-400:!py-4 flex items-center relative w-full max-350:text-sm">
            <DocumentTextIcon className="!mr-2" />
            <span className="font-[450] text-main-dark mr-auto">{capitalizeFirstLetter(name)}</span>
            <span className="text-main-grey">{extension}</span>
            <Arrow2Icon className="!ml-[18px]" />
            {showDelete && (
                <DeleteIcon
                    className="absolute cursor-pointer -right-10 max-950:hidden"
                    onClick={deleteFile}
                />
            )}
        </div>
    );
};

export default SupportDocs;
